<div class="chart-empty">
    <img src="assets/icons/no_data.svg" alt="" class="chart-empty-icon" >
    <span>{{ msgText ? msgText : ('IP.DASHBOARD.GRAPHIC.NO_DATA'| translate)}}</span>
  </div>